<template lang="pug">
    h3.scene--text {{ title }}
</template>
<script>
let sceneTitle = new TimelineLite()
export default {
    data() {
        return {
            done: false,
            paused: false
        }
    },
    props: {
        title: {
            type: String,
            required: true
        }
    },
    mounted() {
        console.log('sceneTitle mounted')
        this.sceneTitleShow()
    },
    beforeDestroy() {
        console.log('sceneTitle before destroy')
        sceneTitle.kill()
    },
    methods: {
        sceneTitleShow() {
            console.log('sceneTitle started')
            sceneTitle
                .to('.scene--text', 2, { autoAlpha: 1 }, '+=2')
                .to('.scene--text', 1.75, { autoAlpha: 0, onComplete: this.sceneTitleDone }, '+=2')
        },
        sceneTitleDone() {
            this.$emit('sceneTitleDone')
            this.done = true
        }
    }
}
</script>
<style lang="scss" scoped>
.scene--text {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/sceneTitle.vue